<template>
    <div class="ui centered grid">

        <div class="sixteen wide column ">
            <div class="ui items">
             
                <div class="item" v-for="item in itemList" :key="item.xml_id"  v-bind:id="((highlight==item.xml_id)? 'highlight' : '')" v-bind:class="{ 'highlight':(highlight==item.xml_id),kk:(item.object[0].type!='painting' && item.object[0].type!='drawing')}" >
                     
                    <div class="ui tiny image" style="width:70px">
                      <!-- <img v-if="hasOwnDeepPropertyv2(item,'object[0].images')" v-bind:src="'/static/images/thumb-'+item.object[0].images[0].file.split('.')[0]+'.png'">-->
                         <img v-if="inventoryImage(item)!=false" v-bind:src="inventoryImage(item)">
                       <TheInventoryIcon v-else v-bind:inventory="item.inventory.name"></TheInventoryIcon>
                    </div>
                    <div class="content">
                       <div v-if="item.object[0].hasOwnProperty('name')" style="font-weight: normal;" class="header italic" >{{personName(item)}}</div>
                        <span v-if="item.object[0].hasOwnProperty('name')"><br></span>
                       <!-- <div v-if="item.hasOwnProperty('caption')" class="header">{{item.caption}}<span v-if="hasOwnDeepProperty(item,'object_info.origDate')">, {{item.object[0].origDate}}</span></div>-->
                         <div v-if="hasOwnDeepPropertyv2(item,'object[0].caption')" class="header">{{item.object[0].caption}}</div>
                        <div v-else class="header">{{item.title}}</div>
                        
                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell" style="width:55%"><span class="italic">{{item.original_inventory_id}}</span> 
                                <!--    <span v-if="item.hasOwnProperty('overstrike')" v-html="overstriked_text">{{overstrike(item)}}</span>-->
                                   <!-- <span v-else>{{boldTitle(item)}}</span></span></div>-->
                                    <span v-html="highlightText(item)"></span></div>
                                  </div>
                            </div>
                        </div>
                    </div>
                    <router-link :to="{ path: '/item/' + item.xml_id }" style="position:absolute;width:95%; height:70px"><div style="position:absolute;width:100%; height:70px"></div></router-link>
                </div>
              
            </div>
        </div>
    </div>

</template>

<script>
    import TheInventoryIcon from '../components/TheInventoryIcon.vue'
    export default {
        components: {
            TheInventoryIcon
        },
        props: ['itemList', 'highlight'],
        data() {
            return {
                person: "",
                overstriked_text: ""
            }
        },
        methods: {

            /*  overstrike: function(item) {
                  var rgx = new RegExp(item.overstrike, "i");
                  this.overstriked_text = item.text.replace(rgx, function(str) {
                      return "<span style='text-decoration: line-through;'>" + str + "</span>";
                  });
              },*/


            highlightText: function(item) {
                var output = item.text
                if (item.hasOwnProperty('overstrike')) {

                    var rgx = new RegExp(item.overstrike, "i");
                    output = item.text.replace(rgx, function(str) {
                        return "<span style='text-decoration: line-through;'>" + str + "</span>";
                    });
                }
                if (item.inventory.name == '1610_19_Vienna') {
                    output = item.text.replace(item.title, '<b>' + item.title + '</b>');
                    /*  var rgx = new RegExp(item.title, "i");
                      output = item.text.replace(rgx, function(str) {
                          return "<b>" + str + "</b>";
                      });*/
                }

                return output;

            },

            inventoryImage: function(item) {
                for (var i in item.object){
                    if (item.object[i].hasOwnProperty('images'))
                          return "/static/images/thumb-" +item.object[i].images[0].file.split('.')[0]+'.png'
                }
                return false;
            },

            callItemPage: function(id) {
                this.$router.push({ path: '/item/' + id });
            },

            hasOwnDeepProperty: function(obj, path) {
                var arr;
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    arr = path[i].match(/(.+)\[(\d+)\]/mi);

                    if (arr != null) {
                        if (arr.length == 3) {
                            if (obj[arr[1]]) obj = obj[arr[1]][arr[2]];
                            else return false;
                        }
                    }
                    else obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },

            hasOwnDeepPropertyv2: function(obj, path) {
                path = path.split('.');
                for (var i in path) {
                    if (path[i].match(/\[\d+\]/mi) == null) {
                        if (obj.hasOwnProperty(path[i])) {
                            obj = obj[path[i]];
                        }
                        else {
                            return false
                        }
                    }
                    else {
                        var matchArr = path[i].match(/\[(\d+)\]/mi);
                        obj = obj[path[i].replace(/\[\d+\]/mi,'')];
                        if (obj[matchArr[1]]) {
                            obj = obj[matchArr[1]]
                        }
                        else {
                            return false
                        }
                    }
                }
                return true
            },

            personName: function(item) {

                var ret = "";
                var personas = {};
                var role = "artist"
                for (var i in item.object[0].name) {
                    if (item.object[0].name[i].hasOwnProperty('role')) {
                        role = item.object[0].name[i].role;
                    }
                    if (item.object[0].name[i].hasOwnProperty('getty_data')) {
                        personas[role] = item.object[0].name[i].getty_data.display_name;

                    }
                    else {
                        personas[role] = item.object[0].name[i].value;
                    }
                }
                
           
                
                
                if (this.hasOwnDeepProperty(item, 'src.value')) {
                    if (item.src.value == 'copy') {
                        if (personas.hasOwnProperty('copist')) {
                            ret += personas.copist + " "
                        }
                        ret += " (copy after";
                        if (personas.hasOwnProperty('artist')) {
                            ret += " " + personas.artist + ")"
                        }
                        else {
                            ret += ")"
                        }
                    }
                    else if (personas.hasOwnProperty('artist')) {
                        ret += personas.artist + "";
                    }
                }
                else if (personas.hasOwnProperty('artist')) {
                    ret += personas.artist + "";
                }
                this.person = ret;
                return ret;
            },
        },
        mounted() {
           
            setTimeout(function() {
                $('#highlight').transition('pulse')
            }, 1000)
            //   this.personName();
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .divTable {
        display: table;
        width: 100%;
    }

    .divTableRow {
        display: table-row;
    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
    }

    .divTableCell,
    .divTableHead {
        border: 0px solid #999999;
        display: table-cell;
        padding: 5px 30px 5px 0px;
    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
        font-weight: bold;
    }

    .divTableFoot {
        background-color: #EEE;
        display: table-footer-group;
        font-weight: bold;
    }

    .divTableBody {
        display: table-row-group;
    }

    .italic {
        font-style: italic;
    }

    .blue1623 {
        color: #2C345C !important;
    }

    .red1621 {
        color: #974F53 !important;
    }

    .highlight {
        background-color: #e6e6e6!important;
        border: 5px solid #e6e6e6!important;
    }

    .kk {
        opacity: 0.6;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheListView.vue